import React, { useState, useEffect, useMemo } from 'react';
import { getPlayerPillarScores } from '../api';
import PillarBubbleSpider from './PillarBubbleSpider';

// Stage 5b's single-player detail view (photo/crest badge + 5-pillar honeycomb + period
// toggle), extracted 2026-07-23 (Stage 7b) so the Lineup Builder's card-click detail panel
// can reuse the exact same component IndividualReport.js uses for its own non-comparison
// view, rather than a second implementation. Fetches its own data from `player.id` + `period`
// — the caller only needs to hand it a player row (must have id/name/position/photo_url) and
// own the period state.
function normalizePillars(row) {
  const n = v => (v === null || v === undefined ? null : Number(v));
  return {
    physical: n(row?.physical), technical: n(row?.technical), tactical: n(row?.tactical),
    identity: n(row?.identity), availability: n(row?.availability),
  };
}

export default function PlayerDetailPanel({ player, period, onPeriodChange, bubbleLinks }) {
  const [score, setScore] = useState(null);

  useEffect(() => {
    if (!player?.id) { setScore(null); return; }
    getPlayerPillarScores(player.id, period).then(row => setScore(row)).catch(() => setScore(null));
  }, [player?.id, period]);

  const pillars = useMemo(() => normalizePillars(score), [score]);
  const stars = score?.stars != null ? Number(score.stars) : null;

  if (!player) return null;

  return (
    <PillarBubbleSpider
      centerImageUrl={player.photo_url || null}
      centerImageFill
      centerInitial={(player.name || '?').charAt(0).toUpperCase()}
      title={player.name}
      subtitle={player.position || null}
      stars={stars}
      pillars={pillars}
      period={period}
      onPeriodChange={onPeriodChange}
      bubbleLinks={bubbleLinks || {}}
      bottomReserve={50}
    />
  );
}
